import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { TherapistDto } from '@therapist/shared/models/therapist/therapist.dto';
import { TherapistApiService } from '@therapist/shared/services/api/therapist-api.service';
import { Observable, tap } from 'rxjs';
import { TherapistAccessStateEnum } from '@therapist/shared/models/subscription/therapist-access-state.enum';

@Injectable({ providedIn: 'root' })
export class TherapistStateService {

  readonly #therapistApiService = inject(TherapistApiService);

  readonly currentTherapist: WritableSignal<TherapistDto | null> = signal(null);

  /** Zugriffszustand aus dem Profil; fehlt er (altes Backend), gilt der Therapeut als nicht gesperrt. */
  readonly accessState: Signal<TherapistAccessStateEnum | null> = computed(() => this.currentTherapist()?.accessState ?? null);
  readonly isLocked: Signal<boolean> = computed(() => this.accessState() === TherapistAccessStateEnum.Locked);

  loadTherapistProfile$(): Observable<TherapistDto> {
    return this.#therapistApiService.getProfile().pipe(
      tap((data: TherapistDto) => this.currentTherapist.set(data))
    );
  }

  getCurrentTherapist(): Signal<TherapistDto | null> {
    return this.currentTherapist.asReadonly();
  }

  setCurrentTherapist(therapist: TherapistDto): void {
    this.currentTherapist.set(therapist);
  }

  removeAll(): void {
    this.currentTherapist.set(null);
  }
}
